import { z } from 'zod';
import { uuidSchema } from '../const/uuidSchema';

const HEX_COLOR_REGEX = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

export const colorInputSchema = z.object({
    id: uuidSchema.optional(),

    name: z
        .string({ required_error: 'укажите название цвета', invalid_type_error: 'название должно быть строкой' })
        .trim()
        .min(1, 'введите название цвета')
        .max(300, 'название не должно превышать 300 символов'),

    value: z
        .string({ required_error: 'укажите цвет', invalid_type_error: 'цвет должен быть строкой' })
        .trim()
        .regex(HEX_COLOR_REGEX, 'цвет должен быть в формате #RGB или #RRGGBB'),
});

export type ColorInputSchema = z.infer<typeof colorInputSchema>;
